class Transaction {
    constructor({ date, stockId, stockName, stockSymbol, transactionType, shareCount, averageShareCost, postTransactionStockMarketValue, postTransactionStockShareCount }) {
        this._date = date
        this._stockId = stockId
        this._stockName = stockName
        this._stockSymbol = stockSymbol
        this._transactionType = transactionType
        this._shareCount = shareCount
        this._averageShareCost = averageShareCost
        this._postTransactionStockMarketValue = postTransactionStockMarketValue
        this._postTransactionStockShareCount = postTransactionStockShareCount
    }

    get date() { return this._date }
    get stockId() { return this._stockId }
    get stockName() { return this._stockName }
    get stockSymbol() { return this._stockSymbol }
    get transactionType() { return this._transactionType }
    get shareCount() { return this._shareCount }
    get averageShareCost() { return this._averageShareCost }
    get postTransactionStockMarketValue() { return this._postTransactionStockMarketValue }
    get postTransactionStockShareCount() { return this._postTransactionStockShareCount }

    get transactionInfo() {
        return `${this._shareCount} @ ${this._averageShareCost} = `
    }

    get totalTransactionCost() {
        return this._shareCount * this._averageShareCost
    }
}

export default Transaction